// utils/rolePermissions/rolesB.ts - utils/rolePermissions/permissions.ts object split (part rolesB)


export const rolesB = {

  'Customer service': {
    menus: [
      'dashboard',
      // Order management - full access
      'orders', 'order_list', 'abandoned_carts', 'digital_orders',
      // Customer management
      'customers',
      // View products for reference
      'products', 'product_list', 'form_list', 'digital_products',
      // Reports
      'reports', 'cs_reports', 'stock_reports',
      // Earnings
      'earnings',
      // WA Bot & Prospek
      'wa_bot', 'prospek',
      // Pengiriman Everpro
      'everpro', 'mengantar', 'lincah'
    ],
    features: [
      // Data export
      'export_csv',
      // Order management - full access
      'change_order_status', 'manual_order_creation',
      // Reports
      'view_reports',
      // Financial access
      'view_earnings',
      // Dashboard widgets
      'view_sales_stats', 'view_recent_orders',
      // WhatsApp management
      'manage_whatsapp', 'view_whatsapp_logs', 'whatsapp_automation',
      // Prospek Chat
      'manage_prospek_followup', 'manage_prospek_checkout'
    ],
  },

  'SPV Customer Service': {
    menus: [
      'dashboard',
      // Order management - full access (brand scope, semua order brand)
      'orders', 'order_list', 'abandoned_carts', 'digital_orders',
      // Customer management
      'customers',
      // View products for reference
      'products', 'product_list', 'form_list', 'digital_products',
      // Reports
      'reports', 'cs_reports', 'stock_reports',
      // Earnings
      'earnings',
      // WA Bot & Prospek
      'wa_bot', 'prospek',
      // Kelola tim CS
      'cs_management',
      // Pengiriman Everpro
      'everpro', 'mengantar', 'lincah'
    ],
    features: [
      // Data export
      'export_csv',
      // Order management - full access + assign ke CS
      'change_order_status', 'manual_order_creation', 'assign_order_cs',
      // Reports
      'view_reports',
      // Financial access
      'view_earnings',
      // Dashboard widgets
      'view_sales_stats', 'view_recent_orders', 'view_top_cs',
      // WhatsApp management
      'manage_whatsapp', 'view_whatsapp_logs', 'whatsapp_automation',
      // Prospek Chat
      'manage_prospek_followup', 'manage_prospek_checkout'
    ],
  },

  'Gudang': {
    menus: [
      'dashboard',
      'orders', 'order_list',
      'digital_products', 'digital_orders',
      'reports', 'stock_reports',
      'wa_bot', 'prospek'
    ],
    features: [
      'change_order_status',
      'export_csv', 'view_reports',
      'view_recent_orders'
    ],
  }
};

